import type { TrigKey } from './keys';

export const fa: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'ریاضی · مثلثات',
  'panel.experiment': 'آزمایش',
  'panel.params': 'پارامترها',
  'panel.scene': 'یک آزمایش انتخاب کنید',
  'experiment.right-triangle.label': 'مثلث قائم‌الزاویه',
  'experiment.unit-circle.label': 'دایرهٔ واحد',
  'experiment.wave-studio.label': 'استودیوی موج',
  'experiment.identity-playground.label': 'این‌همانی‌ها',
  'experiment.triangle-solver.label': 'حلگر مثلث',
  'experiment.circular-polar.label': 'دایره‌ای و قطبی',
  'hint.line1': 'نقاط را بکشید و لغزنده‌ها را حرکت دهید.',
  'hint.line2': 'محتوای آموزشی در هندسه جای دارد، نه در متن.',
  'rt.angle.a': 'زاویهٔ A',
  'rt.angle.b': 'زاویهٔ B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'رادیان',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': 'چسبیدن به 30°/45°/60°',
  'uc.units': 'یکاها',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': 'نمایش ASTC',
  'uc.snap.common': 'چسبیدن به زاویه‌های پرکاربرد',
  'uc.angle.value': '∠',
  'uc.units.deg': 'درجه',
  'uc.units.rad': 'رد',
  'uc.units.both': 'درجه+رد',
  'ws.fn': 'تابع',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — دامنه',
  'ws.frequency': 'B — بسامد',
  'ws.phase': 'C — جابه‌جایی فاز',
  'ws.shift': 'D — جابه‌جایی عمودی',
  'ws.rform.toggle': 'اشتقاق فرم R',
  'ws.rform.a': 'a (ضریب sin)',
  'ws.rform.b': 'b (ضریب cos)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'تنظیم مجدد',
  'ws.base': 'نمایش منحنی پایه',
  'ip.id.pythagorean': 'فیثاغورثی',
  'ip.id.reciprocal': 'وارون',
  'ip.id.quotient': 'خارج‌قسمت',
  'ip.id.sum': 'جمع',
  'ip.id.difference': 'تفاضل',
  'ip.id.double': 'زاویهٔ دوبرابر',
  'ip.id.half': 'نیم‌زاویه',
  'ip.play': 'پخش',
  'ip.pause': 'مکث',
  'ip.step': 'گام',
  'ip.reset': 'تنظیم مجدد',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'در v2 — این اثبات به ساختار مفصل‌تری نیاز دارد.',
  'ts.area': 'مساحت',
  'ts.sineRule': 'قانون سینوس‌ها',
  'ts.cosineRule': 'قانون کسینوس‌ها',
  'ts.ambiguous.toggle': 'نمایش مثلث شبح در ابهام',
  'ts.reset': 'بازنشانی به متساوی‌الاضلاع',
  'ts.snap.integers': 'چسبیدن به اعداد صحیح',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'اضلاع',
  'ts.section.angles': 'زاویه‌ها',
  'ts.section.sineRule': 'قانون سینوس‌ها',
  'ts.section.cosineRule': 'قانون کسینوس‌ها',
  'ts.section.area': 'مساحت',
  'cp.omega': 'سرعت زاویه‌ای',
  'cp.plot.y': 'رسم y (sin)',
  'cp.plot.x': 'رسم x (cos)',
  'cp.polar.label': 'شکل قطبی',
  'cp.polar.circle': 'دایره (r = 1)',
  'cp.polar.rose': 'گل سرخ (r = sin 3θ)',
  'cp.polar.cardioid': 'قلبواره (r = 1 + cos θ)',
  'cp.polar.limacon': 'لیماسون (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'تقریب زاویهٔ کوچک (sin x ≈ x)',
  'cp.play': 'پخش',
  'cp.pause': 'مکث',
  'cp.reset': 'تنظیم مجدد',
  'cp.step': 'گام π/12',
};
